<div class="descriptionText">
	{{ report.description }}
</div>
<div class="card m-2">
	<div class="d-flex">
		<div class="mt-1 mx-2">
			<span class="p-float-label">
				<p-calendar #startDatePicker [(ngModel)]="startDate"></p-calendar>
				<label for="startDate">Start Date</label>
			</span>
		</div>
		<div class="mt-1 mx-2">
			<span class="p-float-label">
				<p-calendar #endDatePicker [(ngModel)]="endDate"></p-calendar>
				<label for="startDate">End Date</label>
			</span>
		</div>
		<p-button pRipple styleClass="p-button-raised p-button-success mt-1 ms-auto" (click)="onDateChange()">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">Run Report</div>
			</ng-template>
		</p-button>
	</div>
</div>
<p-chart #productPerformance type="bubble" [data]="chartConfig.data" [options]="chartConfig.options"></p-chart>
